var _defs, _g, _g2, _g3, _g4, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotivationsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "14a82921b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81 110.59375 L 729 110.59375 L 729 699.742188 L 81 699.742188 Z M 81 110.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1059e423b9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 148.5 110.59375 L 661.5 110.59375 C 698.777344 110.59375 729 140.816406 729 178.09375 L 729 631.90625 C 729 669.183594 698.777344 699.40625 661.5 699.40625 L 148.5 699.40625 C 111.222656 699.40625 81 669.183594 81 631.90625 L 81 178.09375 C 81 140.816406 111.222656 110.59375 148.5 110.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "10d2145885"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 404 238 L 611.980469 238 L 611.980469 573.9375 L 404 573.9375 Z M 404 238 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5cffeb4eab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 505.433594 239.324219 L 404.773438 360.117188 C 404.335938 360.640625 404.242188 361.371094 404.53125 361.988281 C 404.824219 362.605469 405.441406 363 406.125 363 L 461.894531 363 C 462.890625 363 463.847656 363.398438 464.550781 364.101562 C 465.253906 364.804688 465.648438 365.757812 465.648438 366.753906 L 465.648438 570.183594 C 465.648438 571.179688 466.046875 572.136719 466.75 572.839844 C 467.453125 573.542969 468.40625 573.9375 469.402344 573.9375 L 546.265625 573.9375 C 547.261719 573.9375 548.21875 573.542969 548.921875 572.839844 C 549.625 572.136719 550.019531 571.179688 550.019531 570.183594 L 550.019531 366.753906 C 550.019531 365.757812 550.417969 364.804688 551.121094 364.101562 C 551.824219 363.398438 552.777344 363 553.773438 363 L 609.546875 363 C 610.226562 363 610.847656 362.605469 611.136719 361.988281 C 611.425781 361.371094 611.332031 360.640625 610.894531 360.117188 L 510.238281 239.324219 C 509.644531 238.609375 508.765625 238.195312 507.835938 238.195312 C 506.90625 238.195312 506.027344 238.609375 505.433594 239.324219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a0f5ff3d47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 318.085938 405.019531 L 402.460938 405.019531 L 402.460938 573.75 L 318.085938 573.75 Z M 318.085938 405.019531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "40855717ea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 325.59375 405.019531 L 394.953125 405.019531 C 399.097656 405.019531 402.460938 408.382812 402.460938 412.527344 L 402.460938 566.222656 C 402.460938 570.367188 399.097656 573.730469 394.953125 573.730469 L 325.59375 573.730469 C 321.445312 573.730469 318.085938 570.367188 318.085938 566.222656 L 318.085938 412.527344 C 318.085938 408.382812 321.445312 405.019531 325.59375 405.019531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "58c38536f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 196.929688 468.226562 L 281.308594 468.226562 L 281.308594 573.679688 L 196.929688 573.679688 Z M 196.929688 468.226562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9cf085b973"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 204.441406 468.226562 L 273.796875 468.226562 C 277.945312 468.226562 281.308594 471.585938 281.308594 475.730469 L 281.308594 566.15625 C 281.308594 570.304688 277.945312 573.664062 273.796875 573.664062 L 204.441406 573.664062 C 200.292969 573.664062 196.929688 570.304688 196.929688 566.15625 L 196.929688 475.730469 C 196.929688 471.585938 200.292969 468.226562 204.441406 468.226562 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#14a82921b3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1059e423b9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#397da2",
    d: "M 81 110.59375 L 729 110.59375 L 729 699.109375 L 81 699.109375 Z M 81 110.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#10d2145885)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5cffeb4eab)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(2.639821, 0, 0, 2.63995, 402.37135, 236.438211)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 39.041374 1.093205 L 0.909943 46.848981 C 0.744212 47.047256 0.708699 47.323954 0.8182 47.557742 C 0.92918 47.791529 1.162979 47.940976 1.421934 47.940976 L 22.548188 47.940976 C 22.925521 47.940976 23.288058 48.091902 23.554411 48.358242 C 23.820764 48.624582 23.970218 48.985621 23.970218 49.362937 L 23.970218 126.42109 C 23.970218 126.798405 24.121152 127.160924 24.387505 127.427264 C 24.653858 127.693604 25.014915 127.843051 25.392249 127.843051 L 54.509101 127.843051 C 54.886435 127.843051 55.248971 127.693604 55.515324 127.427264 C 55.781678 127.160924 55.931131 126.798405 55.931131 126.42109 L 55.931131 49.362937 C 55.931131 48.985621 56.082065 48.624582 56.348418 48.358242 C 56.614771 48.091902 56.975828 47.940976 57.353162 47.940976 L 78.480896 47.940976 C 78.73837 47.940976 78.973649 47.791529 79.08315 47.557742 C 79.192651 47.323954 79.157137 47.047256 78.991406 46.848981 L 40.861455 1.093205 C 40.636534 0.822426 40.303593 0.665581 39.951415 0.665581 C 39.599236 0.665581 39.266295 0.822426 39.041374 1.093205 ",
    stroke: "#fcfbfa",
    strokeWidth: 7.964417,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a0f5ff3d47)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#40855717ea)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(2.640596, 0, 0, 2.63995, 318.0853, 405.020616)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.843468 -0.000410755 L 29.110032 -0.000410755 C 30.679576 -0.000410755 31.953259 1.273583 31.953259 2.843511 L 31.953259 61.062526 C 31.953259 62.633933 30.679576 63.906447 29.110032 63.906447 L 2.843468 63.906447 C 1.272445 63.906447 0.00024131 62.633933 0.00024131 61.062526 L 0.00024131 2.843511 C 0.00024131 1.273583 1.272445 -0.000410755 2.843468 -0.000410755 ",
    stroke: "#fcfbfa",
    strokeWidth: 6.826644,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#58c38536f3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9cf085b973)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(2.640596, 0, 0, 2.639821, 196.931506, 468.226172)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.844017 0.000147758 L 29.109102 0.000147758 C 30.680126 0.000147758 31.953808 1.272725 31.953808 2.842729 L 31.953808 37.09724 C 31.953808 38.668724 30.680126 39.941301 29.109102 39.941301 L 2.844017 39.941301 C 1.272994 39.941301 -0.000688819 38.668724 -0.000688819 37.09724 L -0.000688819 2.842729 C -0.000688819 1.272725 1.272994 0.000147758 2.844017 0.000147758 ",
    stroke: "#fcfbfa",
    strokeWidth: 6.826644,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-0.000000000000176813, 2.639153, -2.636728, -0.000000000000176651, 243.021831, 405.0054)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 1.500271 1.500127 L 15.488836 1.500127 ",
    stroke: "#fcfbfa",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-0.000000000000176813, 2.639153, -2.636728, -0.000000000000176651, 364.17564, 341.794455)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 1.500273 1.500682 L 15.488839 1.500682 ",
    stroke: "#fcfbfa",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotivationsLogo);
export default __webpack_public_path__ + "static/media/motivationsLogo.2e118f0c379389c22248df32c1cfdf22.svg";
export { ForwardRef as ReactComponent };